import TruncatingText from '@app/src/components/Ui/TruncatingText'
import type { LinkProps } from '@mui/material'
import { Link } from '@mui/material'
import type { RouterLinkProps } from '@app/src/components/RouterLink'
import RouterLink from '@app/src/components/RouterLink'
import React from 'react'
import ParentCellOrFragment from './ParentCellOrFragment'

type LinkCellProps = {
  label?: string
  disableCell?: boolean
} & (Omit<LinkProps, 'component'> | RouterLinkProps)

const isRouterLink = (link: LinkProps | RouterLinkProps): link is RouterLinkProps =>
  Boolean((link as RouterLinkProps).to)

const LinkCell: React.FC<LinkCellProps> = ({ href, label, disableCell, ...props }) => {
  if (isRouterLink(props)) {
    const labelText = label || props.to.toString()
    return (
      <ParentCellOrFragment disableCell={disableCell}>
        <TruncatingText text={labelText}>
          <RouterLink {...props}>{labelText}</RouterLink>
        </TruncatingText>
      </ParentCellOrFragment>
    )
  }

  const labelText = label || href || ''
  // No href → render plain text rather than a broken "https://undefined" link.
  if (!href) {
    return (
      <ParentCellOrFragment disableCell={disableCell}>
        <TruncatingText text={labelText} />
      </ParentCellOrFragment>
    )
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <TruncatingText text={labelText}>
        <Link
          href={href.includes('://') ? href : `https://${href}`}
          underline="hover"
          rel="noopener noreferrer"
          target="_blank"
          {...props}
        >
          {labelText}
        </Link>
      </TruncatingText>
    </ParentCellOrFragment>
  )
}

export default LinkCell
